import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { NO_REDE_ADS_FILTER_ID } from '../../components/dashboard-filters/dashboard-filters.types';
import { AuthService } from '../../services/auth.service';

export const REDE_ADS_INDISPONIVEL_URL = '/v2/rede-ads-indisponivel';

function resolveNetwork(route: ActivatedRouteSnapshot): number | null | undefined {
    let current: ActivatedRouteSnapshot | null = route;
    while (current) {
        if (current.data['network'] != null) {
            return current.data['network'] as number;
        }
        current = current.parent;
    }

    return undefined;
}

export function parseRedeAdsIdsFromQueryParam(raw: string | null): number[] {
    if (raw == null || raw.trim() === '') {
        return [];
    }

    return raw
        .split(',')
        .map((part) => Number(part.trim()))
        .filter((id) => !Number.isNaN(id));
}

export function hasInactiveRedeAdsQueryFilter(
    raw: string | null,
    isRedeAdsAtiva: (redeAdsId?: number | null) => boolean,
): boolean {
    return parseRedeAdsIdsFromQueryParam(raw).some(
        (id) => id !== NO_REDE_ADS_FILTER_ID && !isRedeAdsAtiva(id),
    );
}

export const RedeAdsAtivaGuard: CanActivateFn = (route) => {
    const network = resolveNetwork(route);
    if (network == null) {
        return true;
    }

    const authService = inject(AuthService);
    const router = inject(Router);

    return authService.ensureProfileHydrated().pipe(
        map(() =>
            authService.isRedeAdsAtiva(network) ? true : router.parseUrl(REDE_ADS_INDISPONIVEL_URL),
        ),
    );
};

export const RedeAdsQueryParamAtivaGuard: CanActivateFn = (route) => {
    const raw = route.queryParamMap.get('rede_ads_id');
    if (raw == null || raw.trim() === '') {
        return true;
    }

    const authService = inject(AuthService);
    const router = inject(Router);

    return authService.ensureProfileHydrated().pipe(
        map(() =>
            hasInactiveRedeAdsQueryFilter(raw, (id) => authService.isRedeAdsAtiva(id))
                ? router.parseUrl(REDE_ADS_INDISPONIVEL_URL)
                : true,
        ),
    );
};
